<div class="content" fxLayout="column">
  <button class="close" (click)="close()" aria-label="Close preview email">
    <mat-icon>close</mat-icon>
  </button>
  @if (loaded) {
    <div fxLayout="column" class="header">
      <div fxLayout="row" class="subject" fxLayoutGap="10px">
        <div fxLayout="row" fxFlex>
          <b [innerHTML]="data.subject | safeHtml"></b>
        </div>
      </div>
      <div fxLayout="row" fxLayoutGap="10px">
        <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="5px">
          <div fxLayout="row" class="subtitles">{{ data.senderName }}</div>
          <div fxLayout="row" fxLayoutAlign="start" class="subtitles">
            &lt;{{ data.sender }}&gt;
          </div>
        </div>
      </div>
      @if (data.sentOn) {
        <div fxLayout="row" class="subtitles" fxLayoutGap="10px">
          <div fxLayout="row" fxFlex>
            {{ data.sentOn | date: 'MMMM dd, yyyy, hh:mm a' }}
          </div>
        </div>
      }
    </div>
  }
  <div
    class="container"
    fxLayout="column"
    fxLayoutAlign="center center"
    [ngStyle]="{ 'background-color': loaded ? 'white' : '' }"
  >
    @if (!(failed$ | async) && loaded == false) {
      <div class="loading">
        <img src="../assets/img/Lineup-Logo-black.svg" />
        <p>loading...</p>
      </div>
    }
    @if (!(failed$ | async)) {
      <div fxFlex class="iframe-container">
        <iframe
          sandbox="allow-same-origin"
          title="Email Content"
          width="100%"
          tabindex="0"
          #iframe
        ></iframe>
      </div>
    } @else {
      <div class="failed">
        <h3>Content is not available</h3>
      </div>
    }
  </div>
  <button
    mat-icon-button
    class="close"
    (click)="close()"
    aria-label="Close preview email"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
